<template>
  <div class="boxs">
    <ul
      class="timeline-wrapper"
      v-for="(item, index) in timelineList"
      :key="index"
    >
      <div class="box">
        <div class="title">{{ `${item.studyYears}:${item.title}` }}</div>
        <div :id="item.studyYears" class="box1">{{ item.studyYears }}</div>
      </div>
      <li class="timeline-item" v-for="(t, i) in item.axisItems" :key="i">
        <div class="timeline-box">
          <div class="long-line" v-for="(it, ind) in 3" :key="ind"></div>
          <div class="out-circle"></div>
          <div class="long-line" v-for="(it, ind) in 7" :key="ind"></div>
        </div>
        <div class="timeline-content">
          <div
            class="timeline-date"
            :style="t.isColor === 1 ? 'color:#FF5925' : 'color:#999999'"
          >
            {{ t.timeAxis }}
          </div>
          <div class="timeline-right">
            <div
              class="timeline-title"
              :style="t.isColor === 1 ? 'color:#FF5925' : 'color:#333'"
            >
              {{ t.bigTitle }}
            </div>
            <div class="timeline-desc">{{ t.summary }}</div>
          </div>
        </div>
      </li>
    </ul>
    <div class="rig">
      <div v-for="(item, index) in timelineList" :key="index">
        <a :href="`#${item.studyYears}`">{{ item.studyYears }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HTimeline",
  props: {
    timelineList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped lang="less">
.boxs {
  min-width: 1050px;
  position: relative;
  height: 100%;
  .rig {
    position: fixed;
    top: 200px;
    right: 77px;
    text-align: center;
    line-height: 508/7px;
    font-size: 24px;
    color: #333333;
    width: 140px;
    height: 508px;
    background-image: url("./images/Group2.png");
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    a {
      text-decoration: none;
    }
  }
  ul.timeline-wrapper {
    list-style: none;
    margin: 0;
    margin-top: 27px;
    margin-left: 194px;
    box-sizing: border-box;
    .box {
      margin-right: -10px;
      width: 300px;
      .box1 {
        height: 20px;
        width: 72px;
        background: linear-gradient(135deg, #6f39f4 34%, #394cf4 100%);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 20px;
      }
      .title {
        font-size: 24px;
        color: #333;
        margin-bottom: 24px;
        font-weight: bold;
      }
    }
  }
}

/* 时间线 */
.timeline-item {
  position: relative;
  margin-top: 10px;
  margin-left: 26px;
  .timeline-box {
    text-align: center;
    position: absolute;

    .out-circle {
      width: 16px;
      height: 16px;
      background: #c8c8c8;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      /*opacity: 0.1;*/
      border-radius: 50%;
      display: flex;
      align-items: center;

      .in-circle {
        width: 8px;
        height: 8px;
        margin: 0 auto;
        background: rgba(14, 116, 218, 1);
        border-radius: 50%;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      }
    }

    .long-line {
      width: 2px;
      height: 5px;
      background: #c8c8c8;
      margin-left: 7px;
      margin-bottom: 5px;
    }
  }

  .timeline-content {
    display: flex;
    box-sizing: border-box;
    margin-left: 20px;
    height: 106px;
    padding: 0 0 0 20px;
    text-align: left;
    padding-top: 28px;
    .timeline-right {
      margin-left: 45px;
      width: 50%;
      .timeline-title {
        font-size: 18px;
        word-break: break-all;
        margin-bottom: 5px;
        color: #333;
        font-weight: 600;
        /*display: inline;*/
      }
      .timeline-desc {
        font-size: 12px;
        color: #333;
      }
    }
    .timeline-date {
      width: 100px;
      font-size: 16px;
      color: #999;
      font-weight: 600;
      margin-bottom: 16px;
    }
  }
}

.timeline-item:last-of-type .timeline-content {
  margin-bottom: 0;
}
</style>
